module.exports = __webpack_public_path__ + "4-82.jpg?728ca5bc18568a4414549d165aeff30c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-82.jpg
// module id = 163
// module chunks = 0